<tc-setup-grid
        #setupGrid
        [readOnly]="true"
        [colDefConfig]="colDefConfig"
        [setupGridComp]="this"
        [disableAdd]="true"
        [disableDelete]="true"
        [dataSource]="this"
        [noSelection]="true">
</tc-setup-grid>